import clsx from 'clsx';
import { type PropsWithChildren } from 'react';

import { container } from './MeterBarChartOverlay.sty.js';
import { useMeterBarLayoutSize } from '../../../shared/context/MeterBarLayoutSize.context.js';
import { elementSize } from '../../../shared/styles/element-size.sty.js';
import { MeterBarChartTooltip } from '../MeterBarChartTooltip/MeterBarChartTooltip.js';

// TODO use shared component for overlays if possible
export const MeterBarChartOverlay = ({ children }: PropsWithChildren) => {
  const { size } = useMeterBarLayoutSize();

  return (
    <div
      className={clsx(container, elementSize({ size }))}
      data-testid="overlay-wrapper"
    >
      <MeterBarChartTooltip />
      {children}
    </div>
  );
};
